// extracted by mini-css-extract-plugin
export default {"accordionList":"faq_accordionList__duQME","accordionItem":"faq_accordionItem__qW-my","accordionBody":"faq_accordionBody__36aPN","accordionButton":"faq_accordionButton__RZsWl"};